import { render, staticRenderFns } from "./PedidoDeCompraAprovacaoDiretorView.vue?vue&type=template&id=35e468ec&scoped=true"
import script from "./PedidoDeCompraAprovacaoDiretorView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraAprovacaoDiretorView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraAprovacaoDiretorView.vue?vue&type=style&index=0&id=35e468ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e468ec",
  null
  
)

export default component.exports